import type { Meta, StoryObj } from "@storybook/react-vite"

import AdminEventsIndexPage from "./events/index"
import AdminJobsIndexPage from "./jobs/index"
import AdminLocationsEditPage from "./locations/edit"
import AdminLocationsIndexPage from "./locations/index"
import AdminLocationsNewPage from "./locations/new"
import AdminProfilesEditPage from "./profiles/edit"
import AdminProfilesShowPage from "./profiles/show"
import AdminSignInIndexPage from "./sign-in/index"
import AdminTransactionShowPage from "./transactions/show"
import AdminTransactionsIndexPage from "./transactions/index"
import AdminUsersIndexPage from "./users/index"
import {
  adminPageProps,
  createPageStory,
  sampleAdminEventRows,
  sampleAdminJobsDashboard,
  sampleAdminLocationDetails,
  sampleAdminLocationFeatureSections,
  sampleAdminLocationFormValue,
  sampleAdminLocationRows,
  sampleAdminTransactionDetail,
  sampleAdminTransactionPaymentMethodOptions,
  sampleAdminTransactionRows,
  sampleAdminTransactionStatusOptions,
  sampleAdminUsers,
  sampleLocationStatusOptions,
  sampleNewAdminLocationFormValue,
  samplePagination,
  sampleTimezones,
} from "../storybook-helpers"

const meta = {
  title: "Pages/Admin",
  tags: ["autodocs"],
  parameters: {
    layout: "fullscreen",
  },
} satisfies Meta

export default meta

type Story = StoryObj<typeof meta>

export const EventsIndex: Story = createPageStory(AdminEventsIndexPage, {
  name: "events/index",
  url: "/events",
  componentProps: {
    events: sampleAdminEventRows,
    pagination: samplePagination,
  },
  pageProps: adminPageProps,
})

export const JobsIndex: Story = createPageStory(AdminJobsIndexPage, {
  name: "jobs/index",
  url: "/jobs",
  componentProps: sampleAdminJobsDashboard,
  pageProps: adminPageProps,
})

export const LocationsIndex: Story = createPageStory(AdminLocationsIndexPage, {
  name: "locations/index",
  url: "/locations",
  componentProps: {
    locations: sampleAdminLocationRows,
    pagination: samplePagination,
    search: "",
    flash: {
      notice: "Ubicación actualizada correctamente.",
    },
  },
  pageProps: adminPageProps,
})

export const LocationsNew: Story = createPageStory(AdminLocationsNewPage, {
  name: "locations/new",
  url: "/locations/new",
  componentProps: {
    location: sampleNewAdminLocationFormValue,
    statusOptions: sampleLocationStatusOptions,
    timezones: sampleTimezones,
  },
  pageProps: adminPageProps,
})

export const LocationsEdit: Story = createPageStory(AdminLocationsEditPage, {
  name: "locations/edit",
  url: "/locations/42/edit",
  componentProps: {
    location: sampleAdminLocationFormValue,
    statusOptions: sampleLocationStatusOptions,
    timezones: sampleTimezones,
    details: sampleAdminLocationDetails,
    features: sampleAdminLocationFeatureSections,
  },
  pageProps: adminPageProps,
})

export const ProfilesEdit: Story = createPageStory(AdminProfilesEditPage, {
  name: "profiles/edit",
  url: "/profile/edit",
  pageProps: adminPageProps,
})

export const ProfilesShow: Story = createPageStory(AdminProfilesShowPage, {
  name: "profiles/show",
  url: "/profile",
  pageProps: adminPageProps,
})

export const SignInIndex: Story = createPageStory(AdminSignInIndexPage, {
  name: "sign-in/index",
  url: "/sign-in",
  pageProps: {
    flash: {
      alert: "Credenciales inválidas para el dominio admin.",
    },
  },
})

export const TransactionsIndex: Story = createPageStory(AdminTransactionsIndexPage, {
  name: "transactions/index",
  url: "/transactions",
  componentProps: {
    transactions: sampleAdminTransactionRows,
    pagination: samplePagination,
    search: "",
    status: "",
    paymentMethod: "",
    statusOptions: sampleAdminTransactionStatusOptions,
    paymentMethodOptions: sampleAdminTransactionPaymentMethodOptions,
  },
  pageProps: adminPageProps,
})

export const TransactionsShow: Story = createPageStory(AdminTransactionShowPage, {
  name: "transactions/show",
  url: "/transactions/5102",
  componentProps: { transaction: sampleAdminTransactionDetail },
  pageProps: adminPageProps,
})

export const UsersIndex: Story = createPageStory(AdminUsersIndexPage, {
  name: "users/index",
  url: "/users",
  componentProps: {
    users: sampleAdminUsers,
    pagination: samplePagination,
    search: "",
  },
  pageProps: adminPageProps,
})
